import { FC } from 'react'

import Logo from '@/components/Logo'

import DefaultHeader from '@/layouts/Header'

const Header: FC = () => {
  return <DefaultHeader before={<Logo />} />
}

export default Header
